import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Film, Plus } from 'lucide-react';

import { useHaptics } from '@/hooks/useHaptics';

/**
 * La scheda «Editor» della sezione Avatar a schede (I-635, tavola A5): raccoglie gli INGRESSI di oggi per i creatori, e nient'altro — la
 * procedura guidata (`/avatars/editor`, a schermo intero) e «Crea» (`/avatars/new`), con gli stessi testi di `Avatars.tsx`. Prima stavano come
 * riga e «+» dentro «I miei»; con le schede «I miei» non li ha piu'.
 *
 * Il cancello e' della ROTTA (`soloCreatoriConStudio` in `router.tsx`, `CreatoreGate`): qui non si ricontrolla il ruolo. ⚠️ «Modifica», «Anima» e
 * «Pubblica nel negozio» della tavola A5 NON sono qui: dipendono dal lotto QAvatar del Studio (PR2) e nessuna rotta di oggi le offre da una lista.
 */
export function AvatarStudio() {
  const { t } = useTranslation('avatars');
  const haptics = useHaptics();
  return (
    <div className="flex flex-col gap-4 px-4 pb-24 pt-5" data-testid="avatar-studio">
      <header className="flex items-baseline justify-between gap-3">
        <h1 className="font-display text-lg font-bold text-fg">{t('sezione.studio.title')}</h1>
        <span className="shrink-0 text-xs text-fg-muted">{t('sezione.studio.reserved')}</span>
      </header>

      <Link
        to="/avatars/editor"
        data-testid="avatar-studio-guidata"
        className="flex items-center justify-between rounded-2xl border border-brand/40 bg-brand/5 px-4 py-3 text-sm transition-opacity active:opacity-80"
      >
        <div className="flex min-w-0 items-center gap-3">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-brand/15 text-brand">
            <Film aria-hidden className="h-5 w-5" />
          </span>
          <div className="flex min-w-0 flex-col">
            <span className="font-bold text-fg">{t('list.editorTitle')}</span>
            <span className="text-[11px] text-fg-muted">{t('list.editorSubtitle')}</span>
          </div>
        </div>
        <span className="rounded-full bg-brand/15 px-2 py-0.5 text-[10px] font-semibold uppercase text-brand">{t('list.beta')}</span>
      </Link>

      <Link
        to="/avatars/new"
        data-testid="avatar-studio-crea"
        onClick={() => haptics.impact('light')}
        className="flex items-center gap-3 rounded-2xl bg-bg-secondary px-4 py-3 text-sm transition-opacity active:opacity-80"
      >
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-brand/15 text-brand">
          <Plus aria-hidden className="h-5 w-5" />
        </span>
        <div className="flex min-w-0 flex-col">
          <span className="font-bold text-fg">{t('list.create')}</span>
          <span className="text-[11px] text-fg-muted">{t('sezione.studio.creaSub')}</span>
        </div>
      </Link>
    </div>
  );
}
